export const FETCH_YARD_IDENTIFIERS_REFRESH = "FETCH_YARD_IDENTIFIERS_REFRESH";
export const FETCH_YARD_IDENTIFIERS_CONTINUE = "FETCH_YARD_IDENTIFIERS_CONTINUE";
export const FETCH_YARD_IDENTIFIERS_SUCCESS = "FETCH_YARD_IDENTIFIERS_SUCCESS";
export const FETCH_YARD_IDENTIFIERS_FAILURE = "FETCH_YARD_IDENTIFIERS_FAILURE";
export const SET_YARD_IDENTIFIERS = "SET_YARD_IDENTIFIERS";
